import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Password from '../../assets/images/password.svg';
import { makeStyles, Typography } from "@material-ui/core";
import CCRCommonHeader from "../common/CCRCommonHeader";
import { useStyles } from "./CCRStyles";

const styles = makeStyles((theme) => ({
    progressStatus: {
        "color": "gray !important"
    },
}));
function CCRResetPassword(props) {
    const { progressStatus, validError } = styles();

    const ccrStyles = useStyles();

    const [passwordError, setPasswordError] = useState("");
    const [isPasswordErrorForPassType, setIsPasswordErrorForPassType] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState("");

    function resetPassword() {
        const { password, confirmPassword } = props.formState;
        const verified = verification(password, confirmPassword);
        if (verified) {
            props.confirmPassword();
        }
    }


    function verification(password, confirmPassword) {
        let isVerified = true;
        var regExp = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,64})");
        if (password == null || password === "") {
            setPasswordError("Password is required");
            isVerified = false;
        } else if (regExp.test(password) === false) {
            setPasswordError(`Password must be between 8 and 64 characters.
            The password must have following:
            <div>&nbsp; -a lowercase letter</div>
            <div>&nbsp; -a uppercase letter</div>
            <div>&nbsp; -a digit</div>
            &nbsp;-a symbol`);
            isVerified = false;
            setIsPasswordErrorForPassType(true)
        } else {
            setPasswordError("");
            setIsPasswordErrorForPassType(false)
        }

        if (confirmPassword == null || confirmPassword === "") {
            setConfirmPasswordError("Confirm Password is required");
            isVerified = false;
        }
        else if (password !== "" && confirmPassword !== "" && password !== confirmPassword) {
            setConfirmPasswordError("Password & Confirm Password must be same");
            isVerified = false;
        }
        else {
            setConfirmPasswordError("");
        }

        return isVerified;
    }

    function passwordchange(e) {
        var regix = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,64})");
        if (e.target.value == null || e.target.value === "") {
            setPasswordError("Password is required");
        } else if (regix.test(e.target.value) === false) {
            setPasswordError(`Password must be between 8 and 64 characters.
            The password must have followings:
            <div>&nbsp;-a lowercase letter</div>
            <div>&nbsp;-a uppercase letter</div>
            <div>&nbsp;-a digit</div>
            &nbsp;-a symbol`);
            setIsPasswordErrorForPassType(true)
        }
        else {
            setPasswordError("");
            setIsPasswordErrorForPassType(false)
        }
        props.onChange(e);
    }

    function confirmPasswordchange(e) {
        if (e.target.value == null || e.target.value === "") {
            setConfirmPasswordError("Confirm Password is required");
        }
        else {
            setConfirmPasswordError("");
        }
        props.onChange(e);
    }

    return (
        <CCRCommonHeader customTemplate={props.customTemplate} header="Reset Password" headerIcon={Password} appType={props.appConfig.appType}>
            <div style={{ padding: '10px 0px 20px' }}>
                <div style={{ fontSize: '14px' }}>
                    Provide your new password.
                </div>
            </div>
            {/* {props.appConfig.isInternalLoginOnly === 'false' */}
            <div style={{ padding: '10px 0px 40px' }}>
                <div style={{ width: '365px' }}>
                    <Typography variant="caption">Password</Typography>
                    <TextField
                        fullWidth
                        autoFocus
                        name="password"
                        variant="standard"
                        placeholder="******"
                        classes={{ root: ccrStyles.customTextField }}
                        type="password"
                        error={passwordError}
                        onChange={passwordchange}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                props.onEnter(e)
                            }
                        }}

                    />
                    <div className={validError} dangerouslySetInnerHTML={{ __html: passwordError }} />
                </div>
                <div style={{ width: '365px', marginTop: '10px' }}>
                    <Typography variant="caption">Confirm Password</Typography>
                    <TextField
                        fullWidth
                        name="confirmPassword"
                        variant="standard"
                        placeholder="******"
                        classes={{ root: ccrStyles.customTextField }}
                        type="password"
                        error={confirmPasswordError}
                        helperText={confirmPasswordError
                            ? confirmPasswordError
                            : ''
                        }
                        onChange={confirmPasswordchange}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                props.onEnter(e)
                            }
                        }}

                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                    <div style={{ background: '#4785FF', height: '25px', width: '300px', borderRadius: '20px', cursor: 'pointer', marginTop: '20px', textAlign: 'center' }} onClick={resetPassword}>
                        <span style={{ color: 'white', fontWeight: 'bold' }}>RESET PASSWORD</span>
                    </div>
                    <div style={{ fontSize: '12px', textAlign: 'center', paddingTop: '10px' }}>
                        {(props.resetPwdStatus)
                            ? <div className={props.resetPwdStatus.indexOf("Error") !== -1 ? ` ${validError}` : ` ${validError} ${progressStatus}`}>
                                {props.resetPwdStatus}
                            </div>
                            : <div className={validError}>
                                {(
                                    isPasswordErrorForPassType === true ? <div><span>Password does not meet the criteria</span></div> : passwordError
                                )}
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div style={{ paddingBottom: '5px' }}>
            </div>
        </CCRCommonHeader>
    );
}

export default CCRResetPassword;
